<template>
  <div class="activity-detail">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" title="活动详情" left-arrow @click-left="$router.back()" />
    <div style="height:46px"></div>
    <div v-if="dataInfo.title" class="activity-detail__body">
      <div class="activity-detail__hero">
        <img :src="bannerSrc" alt="" class="activity-detail__banner" />
      </div>

      <div class="activity-detail__summary">
        <div class="activity-detail__title">{{ dataInfo.title }}</div>
        <div v-if="dataInfo.entitle" class="activity-detail__subtitle">{{ dataInfo.entitle }}</div>
      </div>

      <div class="activity-detail__card">
        <div class="activity-detail__section-title">活动详情</div>
        <div v-if="showPoster" class="activity-detail__promo-wrap">
          <img :src="detailPoster" alt="" class="activity-detail__promo" />
        </div>
        <div class="tables" v-html="dataInfo.content"></div>
      </div>

      <div v-if="dataInfo.memo" class="activity-detail__card">
        <div class="activity-detail__section-title">活动说明</div>
        <div class="tables" v-html="dataInfo.memo"></div>
      </div>

      <div class="activity-detail__safe"></div>
      <div class="bonsf">
        <div v-if="$store.state.token" class="btsdn" @click="doactivityapply">立即申请</div>
        <div v-else class="btsdn" @click="$parent.goNav('/login')">前往登录</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activityInfo',
  data() {
    return {
      dataInfo: {},
      defaultBanner: '/static/image/activity_usdt_banner.jpeg',
      detailPoster: '/static/image/activity_recharge_promo.jpeg',
    };
  },
  computed: {
    // 后台只填了目录（https://api.1919c.top/uploads/）时没有封面图
    bannerOk() {
      let url = this.dataInfo.banner;
      if (!url) return false;
      return !/\/uploads\/?$/.test(url);
    },
    bannerSrc() {
      return this.bannerOk ? this.dataInfo.banner : this.defaultBanner;
    },
    // 详情正文里已经自带配图时，不再重复插入默认海报（否则同一张图会出现两次）
    contentHasImg() {
      return /<img/i.test(this.dataInfo.content || '');
    },
    showPoster() {
      return !this.bannerOk && !this.contentHasImg;
    },
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
    getInfo(id) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.dataInfo = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    doactivityapply() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id }).then(res => {
        that.$parent.hideLoading();
        that.$parent.showTost(1, res.message);
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
.tables {
  font-size: 14px;
  box-sizing: border-box;
  padding: 0;
  line-height: 1.7;
  color: #4a5160;
  max-width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.activity-detail {
  min-height: 100vh;
  background: #f5f7fb;
  overflow-x: hidden;
}
.activity-detail__body {
  padding: 0 12px 12px;
}
.activity-detail__hero {
  overflow: hidden;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(31, 45, 61, 0.08);
  font-size: 0;
}
.activity-detail__banner {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
.activity-detail__summary {
  padding: 18px 6px 8px;
  text-align: center;
}
.activity-detail__title {
  font-size: 20px;
  font-weight: 700;
  color: #2f3440;
  line-height: 1.4;
}
.activity-detail__subtitle {
  margin-top: 6px;
  font-size: 13px;
  color: #7f8897;
}
.activity-detail__card {
  margin-top: 12px;
  padding: 16px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(31, 45, 61, 0.06);
}
.activity-detail__section-title {
  margin-bottom: 14px;
  font-size: 16px;
  font-weight: 700;
  color: #2f3440;
  text-align: center;
}
.activity-detail__promo-wrap {
  margin-bottom: 14px;
  border-radius: 14px;
  overflow: hidden;
  background: #f7f8fc;
  font-size: 0;
}
.activity-detail__promo {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
.activity-detail__safe {
  height: 108px;
}
.bonsf {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: 10px;
  z-index: 95;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  background: hsla(0, 0%, 100%, 0.9);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.14);
  border-radius: 16px;
  backdrop-filter: blur(8px);
  .btsdn {
    display: flex;
    width: 180px;
    height: 42px;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    box-shadow: 1px 6px 16px rgb(219 63 96 / 28%);
    background: linear-gradient(90deg, #ffac30, #fa436a, #f56c6c);
    font-size: 15px;
    font-weight: 600;
    padding: 0 20px;
    color: #fff;
  }
}
</style>

<style lang="scss">
// 非 scoped：本项目 vue-loader 13 不支持 ::v-deep（编译后原样输出会被浏览器丢弃），
// 因此改用非 scoped 样式块，并用 .activity-detail 限定作用范围
.activity-detail .tables img {
  display: block;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  height: auto !important;
  max-height: none !important;
  object-fit: contain !important;
  margin: 0 auto 14px;
  border-radius: 14px;
  box-sizing: border-box !important;
}
.activity-detail .tables p,
.activity-detail .tables div,
.activity-detail .tables span {
  word-break: break-word;
}
.activity-detail .tables table {
  width: 100% !important;
  display: block;
  overflow-x: auto;
  border-collapse: collapse;
}
.activity-detail .tables iframe {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/activityInfo.vue